import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IRoleSummary } from '../interfaces/role.interface';
import {
    ExpensePolicyDTO,
    ExpensePolicyRequest,
    ExpensePolicyTierDTO,
    ExpensePolicyTierRequest,
} from '../interfaces/expense.interface';

export const ExpensePolicyService = {
    getByInstitution: async (): Promise<ExpensePolicyDTO | null> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        try {
            const response = await axios.get(ENDPOINTS.EXPENSE_POLICY.GET_BY_INSTITUTION(institutionId), {
                headers: AuthService.getAuthHeader(),
            });
            return response.data;
        } catch (e: any) {
            if (e?.response?.status === 404) return null;
            throw e;
        }
    },

    listApproverRoles: async (): Promise<IRoleSummary[]> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.EXPENSE_POLICY.APPROVER_ROLES(institutionId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    upsert: async (req: Omit<ExpensePolicyRequest, 'institutionId'>): Promise<ExpensePolicyDTO> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.put(ENDPOINTS.EXPENSE_POLICY.UPSERT, { ...req, institutionId }, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    addTier: async (req: ExpensePolicyTierRequest): Promise<ExpensePolicyTierDTO> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.post(ENDPOINTS.EXPENSE_POLICY.ADD_TIER(institutionId), req, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    updateTier: async (id: string, req: ExpensePolicyTierRequest): Promise<ExpensePolicyTierDTO> => {
        const response = await axios.put(ENDPOINTS.EXPENSE_POLICY.UPDATE_TIER(id), req, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    deleteTier: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.EXPENSE_POLICY.DELETE_TIER(id), {
            headers: AuthService.getAuthHeader(),
        });
    },
};
